import { Expose } from "class-transformer";

import { BaseModel } from "src/shared/models/base.model";

export class HouseClaimCacheRefundBank extends BaseModel {
    @Expose() accountNumber = "";
    @Expose() accountType = "";
    @Expose() bankName = "";
    @Expose() bankCode = "";
    @Expose() currency = "";
}
